import {memo} from 'react'
import {
  IconButton,
  Popover,
  PopoverContent,
  PopoverDescription,
  PopoverHeader,
  PopoverTitle,
  PopoverTrigger,
} from '@/shared/ui'
import {HelpCircle} from 'lucide-react'

interface FocusHintButtonProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

/**
 * Button with "?" icon that opens a popover explaining the focus mode (click on participant video).
 */
export const FocusHintButton = memo(function FocusHintButton({
  open,
  onOpenChange,
}: FocusHintButtonProps) {
  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>
        <IconButton
          variant="default"
          size="small"
          aria-label="Подсказки"
          className="size-8! [&_svg]:size-4! bg-muted text-foreground/80"
        >
          <HelpCircle />
        </IconButton>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80">
        <PopoverHeader>
          <PopoverTitle>Режим фокуса</PopoverTitle>
          <PopoverDescription className="mt-1.5 space-y-1.5">
            <span className="block">Нажми на видео участника, чтобы закрепить его в фокусе.</span>
            <span className="block">
              Участник отобразится крупнее, видео показывается целиком без обрезки. Повторный клик
              открепляет.
            </span>
          </PopoverDescription>
        </PopoverHeader>
      </PopoverContent>
    </Popover>
  )
})
